import { use } from 'react'
import { InternalManCodeOverlayContext } from './InternalManCodeOverlayContext'

export const useShowManCodeInformationOverlay = () => {
  const context = use(InternalManCodeOverlayContext)
  if (!context) {
    return () => {
      throw new Error('useShowManCodeInformationOverlay must be used within a ManCodeOverlayProvider')
    }
  }
  return context.setManCode
}
